export class AddInstitution{
    instituteName?: string
    conPersonName?:string
    conPersonMob?:string
    numOfStudent?:number
    emailId?:string
    address?:string
    logo?:FileCO
    instituteModules?:Array<InstituteModule>

}

export class InstituteModule
{
    id?:number
    moduleId?:number
    price?:number
    discount?:number
    moduleImage?:FileCO


}

export class FileCO
{
    fileId?:number
    fileUUID:string
    fileName?:string
    fileType?:string
    title?: string
}

export class ReqForDemo{
    name?:string
    email?:string
    phone?:string
    organisation?:string
    role?:string
}
export class NewsCateCO {
    id: number
    categoryName: string
}

export class NewsCO {
    id: number
    image: FileCO
    newsTitle: string
    newsDescp: string
    publicationDate: string   //dd/mm/yyyy hh:mm:ss
    category: NewsCateCO
    created_by: UserCO
    status: Status
}

export enum Status {
    ACTIVE='ACTIVE',DRAFT='DRAFT'

}

export class UserCO {

    username: string

    password: string

    whtsappMobNo: ContactCO

    alternateNo: ContactCO
    title: string

    gender: string

    dateOfBirth: any

    age: number

    role: UserRole
    subRole: string
    referralCode: string

    userImage: FileCO
    description: string
    designation: string
    addField: []
    experience: number

    presentAddress: AddressCO
    userId: number

    firstName: string

    lastName: string

    motherName: string

    fatherName: string

    email: ContactCO

    mobileNo: ContactCO
    status: string
    remarks: string
    updated_at: string
    created_at: string
    boolStatus?: boolean;
}

export class ContactCO {
    id: number

    countryCode: string

    phoneNumber: string

    email: string
    belongsTo: string
    verified: boolean

    phoneType: string
    created_at: string
    updated_at: string
}

export class UserRole {
    id: number
    type: string
    descp: string
}

export class AddressCO {
    addressId: number

    addressLine1: string

    addressLine2: string

    addressLine3: string

    addressType: string

    pincode: string

    town: string

    status: string
    updated_at: string
    created_at: string
}


export class APIServerResponse {
    link: string
    location: string
    xhrStatus: string
    status: string
    statusCode: number
    timeStamp: string
    message: string
    data: any
}

export class Leads
{
    id?:number
    reqId?:string
    name?:string
    emailId?:string
    phoneNo?:string
    orgName?:string
    personRole?:string
    reqType?:string
    source?:string
    createdBy?:string
    attachment?:FileCO
    descp?:string
    createdDate?:string
    updatedDate?:string
    status?:Status
    extraFields?:MiscellaneousFileCO
}
export class MiscellaneousFileCO
{
    key?:string
    value?:string   
}

export class FaqCO
{
    id:number
    image:FileCO
    question:string
    answer:string
    publicationDate:string
    category:FaqCateCO
    createdBy:number
    status?:Status
}
export class FaqCateCO
{
    id:number
    categoryName:string
    cateDescp:string
    status:Status
}
export enum EnquiryType {
  Admission = 'ADMISSION',

  Others = 'OTHERS'
}
export interface Announcement {
  id: string;
  title: string;
  message: string;
  ctaText?: string;
  ctaRoute?: string;
  type: 'info' | 'warning' | 'success';
  showOnRoutes: string[];   // ['/home']
  startDate: Date;
  endDate: Date;
}
export class VisitorCO {
id: number;
enquryType:	EnquiryType;
status:	VisitorStatus;
enqNo:	string;
visitorName: string;
emailId:	string;
phoneNo:	string;
gender:	string;
remarks:	string;
source:	SourceType;
enquirydate:	string;
student: StudentCO;
personToMeet: UserCO;
address: AddressCO;
schSession:	SchSessionCO;
school:	SchoolCO;
created_at:	string;
updated_at:	string;
timeIN:	string;
timeOUT:	string;
existingParent: boolean;
idProofType: DocumentType;
idProofNumber:	string;
createdby: UserCO;
visitorRmks: VisitorRemarksCO[];
vistAssign: VisitorAssignCO;
admissionClass?: string;
}
export class VisitorRemarksCO {
id: number;
comments: Remarks;
created_at: string;
updated_at: string;
visitor: {};
attachments: FileCO[];
status: Status;
sysMessage: string;
visitorMessage: VisitorMessageCO;
}
export class VisitorAssignCO {
id: number;
status: Status;
visitor:	{};
userco: UserCO;
}
export class Remarks {
userName: string;
userType: UserType
currentStatus: string;
remarks: string;
date: string;
type: RemarkType;
}
export class VisitorMessageCO {
  id: number;
  message: string;
  type: string;
  sentBy: UserCO;
  modes: MessageMode[];
}
export enum UserType {
  ADMIN = "ADMIN",
  TUTOR = "TUTOR",
  STUDENT = "STUDENT",
  PATADMIN = "PATADMIN",
  UNKNOWN = "UNKNOWN"
}
export enum RemarkType {
  INFO = "Info",
  WARNING = "Warning",
  PRIORITY = "Priority"
}
export enum SourceType {
  WEBSITE = "WEBSITE",

}
export enum MessageMode {
  EMAIL = "EMAIL",
  WHATSAPP = "WHATSAPP",
  PORTAL = "PORTAL"
}

export enum DocumentType {
  AADHAR_CARD = "AADHAR_CARD",
  PAN_CARD = "PAN_CARD",
  DRIVING_LICENSE = "DRIVING_LICENSE",
  PASSPORT = "PASSPORT"
}

export enum VisitorStatus {
  OPEN = "OPEN",
  ASSIGNED = "ASSIGNED",
  RESOLVED = "RESOLVED",
  REJECTED = "REJECTED"
}

export class StudentCO {
    id: number;
    user: UserCO = new UserCO()
    studentClass: ClassCO;
    classList: ClassCO[];
    timeZoneId: string;
    school: SchoolCO;
    grade: string;
    schoolId: string;
    registrationId: number;
    migrationId: number;
    rollNo: number;
    dueAmount: number;
    dateOfJoin: string;
    createdBy: number;
    status: Status;
    remarks: string;
    created_at: string;
    updated_at: string;
    obtainedMarks: number;
    exlIndex: number;
    miscellaneous: StudentMiscellaneous;
    session: SchSessionCO;
    noOfBatches: number
    studentBatches: string
    approvedDateTime:string;
    penNo: string;
    boardRegdNo: string;
    applyAdmissionFeeFrom: string;
    mid: number;
    mEnrlNo: string

}

export class SchoolCO {
    id: number;
    migrationId: number;
    schName: string
    schAbout: string
    schAddLine: string
    cnctPerson: string
    cnctMobNum: string
    cnctEmail: string;
    schCode: string;
    status: Status;
    remarks: string;
    created_at: string;
    updated_at: string
    schInfo: string;
    currSession: {};
    schImg:FileCO;
    schMod: string;
    // modules: InstituteModule[];
    paymentInfo: PaymentInfo;
    enrollMentNoPrefix: string;
    autoEnrollEnabled: boolean;
    admissionCounter: number;
    // schMsgTemplate: string[];
    feeCancellation: boolean;
    govtCode: string;
    board: string;
    // studentFeeView: string;
    // rolePermissions: string[];
    studentAdmission: string;
    webUrl: string;
    cnctLLNo: string
}
export class PaymentInfo {
  txnCharge: number;
  keyId: string;
  keySecret: string;
  currency: string;
  whatsappurl: string;
  whatsappclientid: string;
  apiUrl: string;
  location: LocationCO;
  schoolCode:	string;
  feesReminderNotf:	string;
  receiptSeq:	boolean;
  studentApp:	boolean;
  tutorApp:	boolean;
  portalAttendance: boolean;
  principalSig: FileCO;
  otpAuthForAdmin: boolean;
  feeReceiptType: feeReceiptTypes;
  paymentGateway:PaymentGateways;
  staffDeviceCheck:boolean;
}
export class SchSessionCO{
    id: number;
    status: Status;
    remarks: string;
    created_at: string;
    updated_at: string;
    migrationId: number;
    sessionName: string;
    schoolId: SchoolCO;
    currentSession: boolean;
}

export class StudentMiscellaneous {
is_handicapped: string;
is_rte: string;
category: string;
place_of_birth: string;
aadhar_card_no: string;
board: string;
mark_of_identification: string;
blood_group: string;
fatherMobileNo: string;
fatherEmailId: string;
fatherOccupation: string;
motherName: string;
motherMobileNo: string;
motherEmailId: string;
transport: string;
meals: string;
rfid_card_no: string;
boarding: string;
apaarId: string;
}
export class LocationCO {
  region: Region;
  country: Country;
  city: City;
  latitude: string;
  longitude: string;
  radius: string;
}
export class Region {
  id: number;
  name: string;
  initials: string;
}

export class Country {
  id: number;
  name: string;
  initials: string;
  region: Region;
}

export class City {
  id: number;
  name: string;
  initials: string;
  country: Country;
}
export class ClassCO {
id: number;
migrationId: number;
status: Status;
remarks: string;
created_at: string;
updated_at: string;
className: string;
section: SectionCO;
code: number;
classMaster: ClassMasterCO;
school: SchoolCO;
session: SchSessionCO;
}
export class SectionCO {
id: number;
migrationId: number;
status: Status;
remarks: string;
created_at: string;
updated_at: string;
sectionName: string;
code: string;
school: SchoolCO;
schlSession: SchSessionCO;
}
export class ClassMasterCO {
id: number;
status: Status;
className: string;
school: SchoolCO;
subjects: SubjectMasterCO[];
schlSession: SchSessionCO;
absentMsg: boolean;
cmOrder: number;
}
export class SubjectMasterCO {
id: number;
status: Status;
subjectName: string;
school: SchoolCO;
session: SchSessionCO;
}

export class PageCO{
  id:	number
  status: Status
  name:	string
  school:	number;
  category:	PageCategoryCO[];
}

export class PageCategoryCO{
id:	number
status: Status
category:	PageCategoryType
page:	PageCO
image:PageImageCO[];
document:PageDocumentCO[];
content: PageContentCO[] = [];
}
export class PageContentCO {
id: number;
status: Status;
content: string;
pageTitle: string;
updatedBy: UserCO;
category: PageCategoryCO;
msgOrder:	number;
}
export class PageImageCO{
  id:	number
  status: Status
  file: FileCO = new FileCO();
  msgOrder:	number
  updatedBy: UserCO
  category: PageCategoryCO;
  descp:string;
}

export class PageDocumentCO{
  id:	number
  status: Status
  // file:Array<FileCO>;
  file: FileCO = new FileCO();
  updatedBy: UserCO
  image:PageImageCO
  category:PageCategoryCO;
}

export enum PageCategoryType {
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  Carousel = 'CAROUSEL_SLIDER',
  Director = 'DIRECTOR',
  Chairman = 'CHAIRMAN',
  Principal = 'PRINCIPAL',
  AboutUs = 'ABOUT_US',
  SchEvents = 'SCHOOL_EVENTS',
  Secretary ="SECRETARY",

  CulturalActivities = 'CULTURAL_ACTIVITY',
  Sports = 'SPORTS',

  SchoolCelebration = 'SCHOOL_CELEBERATION',

  GENERAL_INFO = 'GENERAL INFORMATION',

  ABOUT_US_INSTITUTION_QUALITY="ABOUT_US_INSTITUTION_QUALITY",
  ABOUT_US_AIM="ABOUT_US_AIM",
  ABOUT_US_MISSION="ABOUT_US_MISSION",
  ABOUT_US_VISION="ABOUT_US_VISION",
  FACILITIES="FACILITIES",
  OTHER_PEOPLE="OTHER_PEOPLE",

  DIGITAL_SCHOOL = 'DIGITAL_SCHOOL',
  //ACADEMIC SPECIFIC
  FEE_RULES = 'FEE RULES',
  //HEADER SPECIFIC
  PAY_FEES = 'PAY_FEES',
  //Home
  ADMISSION_UPDATE = 'ADMISSION_UPDATE',
  FEATURED_IMAGES = 'FEATURED_IMAGES',
  NEWS_HEADER = 'NEWS_HEADER',
  ACHIEVEMENTS = 'ACHIEVEMENTS',
  //FOOTER SPECIFIC
  FOOTER_SOCIAL_LINKS = 'FOOTER_SOCIAL_LINKS',
}

export enum feeReceiptTypes {
  DOUBLE_A4 = 'DOUBLE_A4', 
  DOUBLE_A5 = 'DOUBLE_A5',
  DOUBLE_A4_CONDITION='DOUBLE_A4_CONDITION',
  DOUBLE_A4_MULTIPLE_MERGED='DOUBLE_A4_MULTIPLE_MERGED', 
  DOUBLE_A4_ONLINE="DOUBLE_A4_ONLINE"
}

export enum PaymentGateways {
  RAZOR_PAY ="RAZOR_PAY",
  ICICI_EAZY_PAY="ICICI_EAZY_PAY",
  CASH_FREE="CASH_FREE", 
  EASEBUZZ="EASEBUZZ"
}


export class WebsiteConfigCO {
  id: number;
  status: Status;
  created_at: string;
  updated_at: string;
  userId: number;
  schooId: number;
  webParameter: WebParameterCO;	
}

export class WebParameterCO {
  id: number;
  status: Status;
  keyName: string;
  value: string;
  show: boolean;
}

export class ThemeCO {
  _meta?: Record<string, string>;
  
  // HEADER
  TOP_HEADER_BACKGROUND_COLOR?: string;
  TOP_HEADER_CODES_COLOR?: string;
  TOP_HEADER_TEXT_DARK_COLOR?: string;
  TOP_HEADER_TEXT_WARNING_COLOR?: string;
  TOP_HEADER_DIVIDER_COLOR?: string;

  NAVBAR_ACTIVE_LINK_COLOR_DESKTOP?: string;
  NAVBAR_COLLAPSE_BACKGROUND_COLOR_MOBILE?: string;
  NAVBAR_LINK_COLOR_MOBILE?: string;
  NAVBAR_ACTIVE_LINK_COLOR_MOBILE?: string;

  PAY_FEES_BTN_BACKGROUND_COLOR?: string;
  PAY_FEES_BTN_TEXT_COLOR?: string;
  PAY_FEES_BTN_BOX_SHADOW?: string;
  PAY_FEES_BTN_HOVER_BACKGROUND_COLOR?: string;
  PAY_FEES_BTN_HOVER_TEXT_COLOR?: string;
  PAY_FEES_BTN_HOVER_TEXT_SHADOW?: string;
  PAY_FEES_BTN_HOVER_BOX_SHADOW?: string;
  PAY_FEES_BTN_FOCUS_BOX_SHADOW?: string;

  //HOME
  ENQUIRY_BTN_TEXT_COLOR?: string;
  ENQUIRY_BTN_BACKGROUND?: string;
  ENQUIRY_BTN_BOX_SHADOW?: string;
  ENQUIRY_BTN_HOVER_BOX_SHADOW?: string;

  SECTION_HEADING_UNDERLINE_COLOR?: string;
  
  PPL_BEHIND_VIS_BACKGROUND_COLOR?: string;
  DIRECTOR_BACKGROUND_COLOR?: string;

  HEADING_COLOR_1?: string;
  DIRECTOR_TITLE_COLOR?: string;
  PRINCIPAL_TITLE_COLOR?: string;

  ABOUT_US_TEXT_PRIMARY_COLOR?: string;
  DIRECTOR_TEXT_PRIMARY_COLOR?: string;
  PRINCIPAL_TEXT_PRIMARY_COLOR?: string;

  // ABOUT_US_FADE_GRADIENT?: string;
  // DIRECTOR_FADE_GRADIENT?: string;
  // PRINCIPAL_FADE_GRADIENT?: string;

  //CONTACT-US
  CONTACT_SECTION_BACKGROUND_COLOR?: string;
  CONTACT_ICON_BACKGROUND_COLOR?: string;
  CONTACT_ICON_COLOR?: string;
  CONTACT_INPUT_BORDER_COLOR?: string;
  CONTACT_INPUT_BACKGROUND_COLOR?: string;
  CONTACT_INPUT_TEXT_COLOR?: string;
  CONTACT_SUBMIT_BTN_BACKGROUND_COLOR?: string;
  CONTACT_SUBMIT_BTN_TEXT_COLOR?: string;


}
